import { useState } from "react";
import { mergeDeep } from "@apollo/client/utilities";

import { useFilterStorage, useMe } from "components/use-hooks";


const useCraftFilterHook = ({
        filter : filterParams = {}
    }) => {

    const { me } = useMe(),
          filterStorage = useFilterStorage();

    const defaultFilter = {
        where : {
            craftType : {},
            subId : {},
            eeId   : {
                column   : "EE_ID",
                operator : "EQ",
                value    : me.eeCurrentId,
            }
        }
    };

    const [ filter, setFilter ] = useState(
        mergeDeep(defaultFilter, filterParams)
    );

    filterStorage.store("hallOverview", {
        filter
    })

    return {
        filter : {
            data  : filter,
            set   : setFilter,
            reset : () => setFilter(defaultFilter)
        }
    };
}

export default useCraftFilterHook;